import { isPlatformServer } from '@angular/common';
import { Component, ElementRef, Inject, Input, OnInit, PLATFORM_ID, SimpleChanges, ViewChild } from '@angular/core';
import { Chart} from 'chart.js';
import { formatNumber, getGradient, indianNumberFormat } from 'src/app/constants/chart.config';

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})
export class ChartComponent implements OnInit {

  @Input() config!: any;
  @Input() data: any;
  @Input() label: any;
  @Input() id:string = 'canvas'
  @ViewChild('chart') canvas: ElementRef<HTMLCanvasElement> | any;
  chart: Chart | any;

  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    setTimeout(()=>{
      this.initializeChart();
      if (this.chart && (this.data || this.label)) {
        this.updateChartData();
      }
    },0)
  }

  initializeChart() {
    if(isPlatformServer(this.platformId)) return 
    if(this.chart) this.chart.destroy();
    if (this.config && this.canvas?.nativeElement) {
      this.chart = new Chart((<any>document.getElementById(this.id)), JSON.parse(JSON.stringify(this.config)));
      this.chart.render()
    }
}

  updateChartData() {
    if (this.chart) {
      this.chart.data.labels = this.label;
      this.chart.data.datasets[0].data = this.data;
      let color1 = ''
      let color2 = ''
      if(this.id.includes('1') || this.id.includes('6')){
        color1 = 'rgba(0, 89, 159, 0.03)';
        color2 = 'rgba(0, 89, 159, 0.5)';
      }else if(this.id.includes('2') || this.id.includes('4')){  
        color1 = 'rgb(243, 134, 0,0.3)';
        color2 = 'rgb(243, 134, 0,0.5)';
        this.chart.data.datasets[0].borderColor = 'rgb(243, 134, 0,0.8)'
      }else{
        color1 = 'rgba(0, 89, 159, 0.5)';
        color2 = 'rgba(0, 89, 159, 0.8)';
      }
      this.chart.data.datasets[0].backgroundColor = function (context: any) {
        const chart = context.chart;
        const { ctx, chartArea } = chart;
        if (!chartArea) return;
        return getGradient(ctx, chartArea,color1,color2);
      }
      this.chart.options.plugins.tooltip.callbacks['label'] =(context:any)=> {
        let label = context.dataset.label || '';
        if (label) {
            label += ': ';
        }
        const format = this.identifyNumber(context.raw);
        if(format){
           const num = context.raw / 10000000
           label += `${num.toFixed(2)} ${format}`
        }else{
          label += context.raw

        }
        return label;
    }
      this.chart.options.scales['y']['ticks']['callback'] = function (value: any, index: any, values: any) {
        return formatNumber(value);
      }
      this.chart.update();
    }
  }

  identifyNumber(number:any) {
    if (number >= 10000000) {
        return "Cr";
    } else if (number >= 100000) {
        return "Lac";
    } else {
        return "";
    }
  }



  ngOnDestroy(){
    this.chart.destroy();
  }

}
